import PrivateNetworkClient from "helpers/privateNetwork";

const shiftList = async (formData) => {
  if (localStorage.getItem('token') === null) {
    return null;
  }
  const { data } = await PrivateNetworkClient.post("/getShiftList", formData);
  return data;
};

const getShift = async (id) => {
  const { data } = await PrivateNetworkClient.get(`/getShift/${id}`);
  return data;
};

const addShift = async (formData) => {
  const { data } = await PrivateNetworkClient.post("/addShift", formData);
  return data;
};

const editShift = async (formData) => {
  const { data } = await PrivateNetworkClient.put("/editShift", formData);
  return data;
};

const deleteShift = async (id) => {
  const { data } = await PrivateNetworkClient.delete(`/deleteShift/${id}`);
  return data;
};

const changeShiftStatus = async (id) => {
  const { data } = await PrivateNetworkClient.put(`/changeShiftStatus/${id}`);
  return data;
};

export {
  shiftList,
  getShift,
  addShift,
  editShift,
  deleteShift,
  changeShiftStatus
};
